import React, { useEffect, useState } from "react";
import { HistoryWrapper } from "./styled";
import {
  Box,
  SubHeadingStyled,
  ThemeLoader,
} from "../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import { SearchIcon } from "../../../components/styled/AllImages";
import FloatingInput from "../../../components/common/inputFields/FloatingInput";
import ListTable from "../../../components/common/tables/ListTable";
import { historyColumns } from "../../../helpers/adminConstants/TableConstants";
import { useNavigate } from "react-router-dom";
import { getFormattedDate } from "../../../utils";
import HistoryApi from "../../../services/api/historyApi";
import { useDebounce } from "../../../hooks/useDebounce";

const History = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // States
  const [history, setHistory] = useState([]);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const [perPage, setPerPage] = useState(null);
  const [totalCount, setTotalCount] = useState(null);

  // Methods
  const onViewDetails = (row) => {
    navigate(`/access-log/access-log-details/${row.id}`);
  };

  const getHistory = async (page = 1, query = "") => {
    try {
      setIsLoadingHistory(true);
      const { data, code } = await HistoryApi.getHistory(page, query);
      if (code === 200) {
        const formattedHistory =
          data?.data &&
          data?.data?.length > 0 &&
          data?.data?.map((item) => ({
            key: item?.id,
            id: parseInt(item?.id),
            date: getFormattedDate(item?.created_at),
            number: item?.number,
            archiveTitle: item?.title,
            views: item?.views_count,
            downloads: item?.downloads_count,
            infoData: [
              {
                title: "cabinet_name",
                value: item?.file_name?.cabinet_name?.name,
              },
              {
                title: "FileName",
                value: item?.file_name?.name,
              },
            ],
          }));
        setHistory(formattedHistory);
        setTotalCount(data?.total);
        setPerPage(data?.per_page);
      } else {
        setHistory([]);
        setTotalCount(null);
        setPerPage(null);
      }
    } catch (error) {
    } finally {
      setIsLoadingHistory(false);
    }
  };

  const handleSearch = (e) => {
    const query = e.target.value.trim();
    setSearchQuery(query); // Update the search query state
  };

  useEffect(() => {
    getHistory(activePage, debouncedSearchQuery);
  }, [activePage, debouncedSearchQuery]); // Trigger when page or search query changes

  return (
    <HistoryWrapper>
      <Box className="content-head">
        <SubHeadingStyled size="18px" weight="700" color="var(--text)">
          {t("access_log")}
        </SubHeadingStyled>

        <Box>
          <FloatingInput
            name="search"
            type="input"
            fieldType="text"
            label={t("search")}
            placeholder={t("search")}
            icon={SearchIcon}
            onChange={handleSearch} // Call the search handler
          />
        </Box>
      </Box>
      <Box>
        {isLoadingHistory ? (
          <ThemeLoader />
        ) : (
          <ListTable
            options={["tooltip", "view"]}
            rows={history}
            columns={historyColumns}
            onViewDetails={onViewDetails}
            totalCount={totalCount}
            perPage={perPage}
            activePage={activePage}
            setActivePage={setActivePage}
          />
        )}
      </Box>
    </HistoryWrapper>
  );
};

export default History;
